import React from "react";
import { FaX } from "react-icons/fa6";

const NuevoMensaje = ({ formMensaje, onChange, onSubmit, onClose }) => {
  return (
    <div className="historico-seguimiento">
      <div className="modal-content">
        <div className="modal-header mayusculas"> 
          <h2 className="mayusculas">Nuevo mensaje</h2>
          <button className="cerrar-modal" onClick={onClose}><FaX /></button>
        </div>
        <div className="modal-body mt-20 mb-10">
          <form onSubmit={onSubmit} className="column gap-10">
            <label className="align-center gap-10 verde bold">
              Servicio que le va a atender:
              <select name="servicio" value={formMensaje.servicio} onChange={onChange} required>
                <option value="">Seleccione una opción</option>
                <option value="SAE">SAE</option>
                <option value="ERACIS">ERACIS</option>
                <option value="Andalucía Orienta">Andalucía Orienta</option>
                <option value="Servicios Sociales">Servicios Sociales</option>
                <option value="Punto Vuela">Punto Vuela</option>
              </select>
            </label>

            <label className="verde bold align-start gap-5 mb-20">
              Asunto:
              <input className="w-100" type="text" name="asunto" value={formMensaje.asunto} onChange={onChange} required />
            </label>

            <label className="verde bold align-start gap-5 mb-20">
              Mensaje:
              <textarea className="w-100" name="mensaje" value={formMensaje.mensaje} onChange={onChange} rows={5} required></textarea>
            </label>

            <button type="submit" className="boton-enviar verde">Enviar mensaje</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NuevoMensaje;
